(function () {
  function isActive() {
    return !!(document.querySelector('.ciw-pdp') || document.querySelector('.cl-section'));
  }

  function isContactLens() {
    return !!document.querySelector('.cl-section');
  }

  function isEyeglass() {
    return !!document.querySelector('.ciw-pdp');
  }

  window.ciwLaHostApi = {
    isActive: isActive,
    isContactLens: isContactLens,
    isEyeglass: isEyeglass
  };
})();
